import { useLocation, Link } from 'react-router-dom';
import { useEffect } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

const routeNames: Record<string, string> = {
  '/': 'Calculator',
  '/male-partner-calculator': 'Male Partner Calculator',
  '/ideal-woman-calculator': 'Ideal Woman Calculator',
  '/dating-standards-calculator': 'Dating Standards Calculator',
  '/faq': 'FAQ',
  '/methodology': 'Methodology',
  '/data-sources': 'Data Sources',
  '/glossary': 'Glossary',
  '/sitemap': 'Sitemap',
  '/stats': 'Statistics',
  '/states': 'States',
  '/about': 'About',
  '/privacy': 'Privacy Policy',
  '/terms': 'Terms of Service',
};

export const Breadcrumbs = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Add structured data for breadcrumbs
  useEffect(() => {
    const breadcrumbList = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://femalepartnercalculator.com/"
        }
      ]
    };

    if (pathSegments.length > 0) {
      pathSegments.forEach((segment, index) => {
        const path = '/' + pathSegments.slice(0, index + 1).join('/');
        breadcrumbList.itemListElement.push({
          "@type": "ListItem",
          "position": index + 2,
          "name": routeNames[path] || segment,
          "item": `https://femalepartnercalculator.com${path}`
        });
      });
    }

    let script = document.querySelector('script[data-breadcrumb-schema]') as HTMLScriptElement;
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-breadcrumb-schema', 'true');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(breadcrumbList);

    return () => {
      const breadcrumbSchema = document.querySelector('script[data-breadcrumb-schema]');
      if (breadcrumbSchema) {
        breadcrumbSchema.remove();
      }
    };
  }, [location.pathname, pathSegments]);

  // Don't show breadcrumbs on home page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <div className="container mx-auto px-4 py-2">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">Home</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {pathSegments.map((segment, index) => {
            const path = '/' + pathSegments.slice(0, index + 1).join('/');
            const isLast = index === pathSegments.length - 1;
            const name = routeNames[path] || segment;

            return (
              <div key={path} className="flex items-center">
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  {isLast ? (
                    <BreadcrumbPage>{name}</BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link to={path}>{name}</Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              </div>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};